import { Box, styled } from "@mui/material"

export const TableWrapper = styled(Box)({
  flex: 1,
  height: "83vh",
  // "& tr": {
  //   // height: "100%",
  // },
  // "& th ": {
  //   "& div": {
  //     padding: 0,
  //   },
  // },
  // "& td ": {
  //   "& div": {
  //     padding: 0,
  //   },
  // },
})

export const NoBucketWrapper = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  height: "100%",
  justifyContent: "center",
})
